<div class="modal-header">
  <h4 class="modal-title">Access List - {{ currentAdmin }} {{ companyCode }}</h4>
  <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()" aria-label="Close"></button>
</div>

<div class="modal-body">
  @if (accessMap.length == 0) {
    <span>Do not have any company access now.</span>
  }
  @for (entry of accessMap; track entry) {
    <div class="pb-4">
      <div class="d-flex gap-2 align-items-center mb-2" (click)="toggleCollapse(entry.key)">
        @if (entry.isCollapsed) {
          <i class="text-secondary fas fa-chevron-down"></i>
        } @else {
          <i class="text-secondary fas fa-chevron-up"></i>
        }
        <h4 class="mb-0">{{ entry.key | titlecase }}</h4>
        <h5 class="mb-0 text-secondary">({{ entry.access.length }})</h5>
      </div>
      <div [ngbCollapse]="entry.isCollapsed">
        <table class="table table-responsive table-custom mb-0 pb-4">
          <thead>
            <tr>
              @if (currentAdmin != undefined) {
                <th>Company</th>
              }
              @if (currentAdmin == undefined) {
                <th>Admin</th>
              }
              <th>Priority</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (access of entry.access; track access; let i = $index) {
              <tr>
                @if (currentAdmin != undefined) {
                  <td>{{ access.CompanyCode }}</td>
                }
                @if (currentAdmin == undefined) {
                  <td>{{ access.Username }}</td>
                }
                <td>{{ access.Priority }}</td>
                <td class="text-end">
                  @if (entry.key === NORMAL_ACCESS) {
                    <i class="fas fa-exchange-alt" style="cursor: pointer; color: #878787" (click)="openChangeAccessModal(access)"></i>
                  } @else {
                    <i class="fas fa-times ms-2" style="cursor: pointer; color: #878787" (click)="openRevokePriorityModal(access, i)"></i>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
        @if (entry.key === TEMPORARY_ACCESS) {
          <div class="d-grid gap-2">
            <button class="btn btn-outline-danger" (click)="openRevokeTemporaryAccessModal()"><i class="fas fa-exclamation-triangle mr-2"></i> Revoke all temporary access</button>
          </div>
        }
      </div>
    </div>
  }
</div>
